import { type ElementType } from 'react';
import { useTranslation } from 'react-i18next';

import { Body } from '../../../components/Typography';
import { SuggestedEntry } from '../../../copied/models/ChatModules';
import TailorSearchResults from './TailorSearchResults';

export default function TailorMostRequested({
  id = 'ostro-tailor-most-requested-container',
  title,
  showArticleDescriptions = true,
  articleTitleComponent,
  searchResults,
  onSelectResult,
}: {
  id?: string;
  title?: string;
  showArticleDescriptions?: boolean;
  articleTitleComponent?: ElementType;
  searchResults?: SuggestedEntry[];
  onSelectResult: (result: SuggestedEntry, index: number) => void;
}) {
  const { t } = useTranslation();

  return (
    <div id={id}>
      <Body
        data-testid="tailor-most-requested-title"
        className="mb-4 text-typography-sectionHeader text-sectionHeader font-sectionHeader"
      >
        {title ?? t('most_requested_resources')}
      </Body>
      <TailorSearchResults
        articleTitleComponent={articleTitleComponent}
        showArticleDescriptions={showArticleDescriptions}
        results={searchResults}
        onSelectResult={onSelectResult}
      />
    </div>
  );
}
